import React, { useEffect, useState } from 'react';
import { createRolePermission, permissionList } from 'src/services/rolesPermission';
import TextWithIconButton from 'src/components/Common/TextWithIconButton';
import rightIcon from 'src/assets/svgs/rightIcon.svg';
import { toaster } from 'src/utils/toaster';
import blueCancelIcon from 'src/assets/svgsResponsive/blueCancelIcon.svg';

interface Permission {
    module: number;
    permissions: any;
}
const AddRolePermission = ({ getRoleList, selectedRowData, setModalOpen, rolePage, isResponsive }: any) => {
    const [permissionListData, setPermissionListData] = useState<Permission[]>([]);

    const controller = new AbortController();
    useEffect(() => {
        getPermissionList(`?roleId=${selectedRowData?.id}`, controller.signal);
        return () => controller.abort();
    }, []);

    const getPermissionList = async (url: string, signal?: any) => {
        try {
            const roleResData = await permissionList(url, signal);
            const data = roleResData?.data?.data;
            const formattedData = data.rolePermissions.map((item: any) => ({
                ...item,
                permissions: item.permissions ? JSON.parse(item.permissions) : [],
            }));
            setPermissionListData(formattedData);
        } catch (error) {}
    };

    const handleChecked = (checked: boolean, row: any) => {
        setPermissionListData((prev: any[]) =>
            prev.map((moduleItem) => {
                let isUpdatedModule = false;

                const updatedPerms = moduleItem.permissions.map((perm: any) => {
                    if (perm.id === row.id) {
                        isUpdatedModule = true;
                        return { ...perm, hasPermission: checked ? 1 : 0 };
                    }
                    return perm;
                });

                if (!isUpdatedModule) return moduleItem;

                const isAllChecked = updatedPerms.every((p: any) => p.hasPermission === 1) ? 1 : 0;

                return {
                    ...moduleItem,
                    permissions: updatedPerms,
                    isAllChecked,
                };
            }),
        );
    };
    const handleCheckedAll = (checked: boolean, moduleName: string) => {
        setPermissionListData((prev: any[]) =>
            prev.map((moduleItem) =>
                moduleItem.module === moduleName
                    ? {
                          ...moduleItem,
                          permissions: moduleItem.permissions.map((perm: any) => ({
                              ...perm,
                              hasPermission: checked ? 1 : 0,
                          })),
                          isAllChecked: checked ? 1 : 0,
                      }
                    : moduleItem,
            ),
        );
    };
    const handleEditAction = (row: any) => (
        <div className={`h-7 justify-center items-center inline-flex cursor-pointer`}>
            <input
                type="checkbox"
                onChange={(e) => {
                    e.stopPropagation();
                    handleChecked(e.target.checked, row);
                }}
                className="mt-3"
                name="is_verified"
                data-id={'final_payment_Date_same'}
                checked={row?.hasPermission === 1}
            />
        </div>
    );
    const handleSave = async () => {
        const selectedPermissions = permissionListData.flatMap((moduleItem) => moduleItem.permissions.filter((perm: any) => perm.hasPermission === 1).map((perm: any) => perm.id));
        try {
            const payload = {
                roleId: selectedRowData?.id,
                permissions: selectedPermissions,
            };
            const res = await createRolePermission(payload);
            if (res.status === 200) {
                getRoleList(`?page=${rolePage}&limit=10`, controller.signal);
                setModalOpen(false);
                toaster('success', res.data.message);
            } else {
                toaster('success', res.data.message);
            }
        } catch (error) {}
    };

    return (
        <div>
            {!isResponsive && (
                <div className=" flex flex-row justify-between w-full  items-center mt-3 mr-4">
                    <div className="text-md font-semibold text-black">Edit {selectedRowData?.display_name} Permission</div>
                    {/* <div className="text-base font-semibold text-black">
                        <TextWithIconButton
                            btnClassName={`w-46 h-12 px-6 py-4 rounded-3xl  bg-secondary shadow justify-center items-center gap-2 inline-flex`}
                            textClassName="text-white text-sm font-bold uppercase"
                            imgClassName="w-6 h-6 relative"
                            icon={rightIcon}
                            textName={'Save'}
                            altName="submit"
                            onClick={handleSave}
                            btnType="button"
                        />
                    </div> */}
                </div>
            )}
            <div className={`${isResponsive ? 'max-lg:flex hidden mb-2' : 'hidden'} justify-between items-center`}>
                <span
                    onClick={() => {
                        setModalOpen(false);
                    }}
                >
                    <img src={blueCancelIcon} alt="blueCancelIcon" className="cursor-pointer  max-md:w-[38px] max-md:h-[38px] max-lg:w-[50px] max-lg:h-[50px]" />
                </span>

                <div className="flex gap-3  items-center justify-center w-full">
                    <span className="text-base font-semibold text-black">Edit {selectedRowData?.display_name} Permission</span>
                </div>
            </div>

            <div className="py-6 lg:block max-h-[calc(100vh-130px)] overflow-y-auto">
                {permissionListData.map((item: any, index: number) => {
                    const details = item.permissions;

                    return (
                        <div key={index} className="max-lg:flex w-full p-[10px] bg-white flex-col rounded-3xl mt-3">
                            <button className="flex items-center justify-between w-full">
                                <div className="flex items-center gap-2 w-1/3">
                                    <div className="text-black max-md:text-xs font-bold uppercase max-lg:text-sm ps-1">{item.module}</div>
                                </div>

                                <div className="max-md:w-1/2 w-1/4 flex justify-end">
                                    <div className={`h-7 justify-center items-center alighn-center inline-flex cursor-pointer gap-2`}>
                                        <span className="text-gray80 text-xs font-medium">All {item.module} permissions </span>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                handleCheckedAll(e.target.checked, item.module);
                                            }}
                                            className=""
                                            name="is_verified"
                                            data-id={'final_payment_Date_same'}
                                            checked={item?.isAllChecked === 1}
                                        />
                                    </div>
                                </div>
                            </button>

                            <div className="px-2.5 border-t-2 mt-3 border-[#C1C1C1] pt-2.5">
                                <div className="grid max-md:grid-cols-1 grid-cols-3 gap-y-2">
                                    {details.map((d: any, i: any) => (
                                        <div key={i} className="flex items-center">
                                            <span className="max-md:w-[180px]  w-[150px] font-bold text-xs text-[#627BE8]">{d.display_name}</span>

                                            <span className="mx-[10px] text-[#627BE8]">:</span>

                                            <span className="font-medium text-xs">{handleEditAction(d)}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
                <div className="text-base flex justify-end font-semibold my-2 text-black me-2">
                    <TextWithIconButton
                        btnClassName={`w-46 h-12 px-6 py-4 rounded-3xl  bg-secondary shadow justify-center items-center gap-2 inline-flex`}
                        textClassName="text-white text-sm font-bold uppercase"
                        imgClassName="w-6 h-6 relative"
                        icon={rightIcon}
                        textName={'Save'}
                        altName="submit"
                        onClick={handleSave}
                        btnType="button"
                    />
                </div>
            </div>
        </div>
    );
};

export default AddRolePermission;
